<template>
  <div>
    <div class="table">
      <el-form :model="form" label-width="120px" :rules="rules" ref="ruleForm">
        <el-form-item label="简介图片" prop="imgUrl">
          <div class="upimg">
            <UploadImg @onSuccess="onSuccess">
              <img v-if="editData" :src="editData" class="avatar" style="width: 100%;height:100%">
              <i v-else size="50" class="el-icon-plus avatar-uploader-icon"></i>
            </UploadImg>
            <!-- <p>建议图片尺寸400*260</p> -->
          </div>
        </el-form-item>

      </el-form>
      <div class="dialog-Btn">
        <el-button size="small" @click="closedialog">取消</el-button>
        <el-button size="small" type="primary" @click="updateData">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import UploadImg from "@/views/models/uploadImg.vue"
import { addClassicCase } from "@/api/case.js";

export default {
  name: 'image_edit',
  props: {
    closedialog: {
      type: Function,
      default: () => { }
    }
  },
  components: {
    UploadImg
  },
  data () {
    return {
      form: {},
      saveData: {},
      editData: '',
    }
  },
  created () {
    this.$nextTick(() => {
      this.editData = this.$store.state.pageTemplateData.thumbnail
      this.saveData = this.$store.state.pageTemplateData
    })
  },
  methods: {
    updateData () {
      this.saveData.thumbnail = this.editData
      addClassicCase(this.saveData).then(res => {
        if (res.code == 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.closedialog()
          this.$store.commit('changeRefresh')
        } else {
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }

      })
    },
    onSuccess (e) {
      console.log(e)
      this.editData = e
    },
  }

}

</script>
<style  lang="scss" scoped>
.dialog-Btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
::v-deep .upimg {
  width: 150px;
  // height: 100px;

  p {
    font-size: 12px;
    color: #999;
  }

  .avatar-uploader {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .el-upload {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-icon-plus {
        font-size: 30px;
        color: #999;
      }
    }
  }
}
</style>